import gql from 'graphql-tag'

export default gql`mutation createOrganizerUser($record: CreateOneOrganizerInput!){
    createOrganizerUser(record:$record){
      recordId
    }
  }`
